import { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  value: number | string;
  index: number | string;
  baseTabId: string;
  [key: string]: any;
}

const TabPanel = ({ children, value, index, baseTabId, ...other }: IProps) => {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`${baseTabId}panel-${index}`}
      aria-labelledby={`${baseTabId}-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
};

export default TabPanel;
